import {
  AI_MODE_HEADER_TOOLTIP,
  MANUAL_MODE_DISABLED_TOOLTIP,
  MANUAL_MODE_HEADER_TOOLTIP,
} from '../constants';
import { useState } from 'react';
import PendoCard from './PendoCard';
import { FirstTimeViewName } from 'types';
import styles from './styles.module.scss';
import { getLabelFromId } from 'utils/aiChat';
import DataActions from './DataActions/index';
import Separator from 'components/UI/Separator';
import { useAppContext } from 'context/AppContext';
import { IconID } from 'packages/radiant-react/icon';
import { Header } from '../../LeftPanel/Header/index';
import { Button } from 'packages/radiant-react/button';
import { Typography } from 'packages/radiant-react/typography';
import { useIsFirstTimeView } from 'hooks/useIsFirstTimeView';
import { Horizontal, Vertical } from 'packages/radiant-react/layout/flex-layout/flex-layout';

export const AiModeHeader = () => {
  const {
    isHeaderLoading,
    setIsHeaderLoading,
    embedSelections,
    onEmbedSelectionChange,
    goBack,
    setMessageHandler,
    openDownloadModal,
    openPasteModal,
    activeView,
    isAiModeActive,
    setIsAiModeActive,
    isStreaming,
  } = useAppContext();
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  const { showView, isSeenView, handleViewHover, handleViewClose } = useIsFirstTimeView(
    FirstTimeViewName.HasSeenManualModeExplainer
  );

  return (
    <Horizontal className={styles['header-container']}>
      <Horizontal className={styles['header-container-left']} vAlignContent="center">
        <Button
          text={AI_MODE_HEADER_TOOLTIP}
          type="secondary"
          size="m"
          className={`${styles['buttons']} ${
            isAiModeActive ? styles['active'] : styles['inactive']
          }`}
          icon={IconID.AI_MODE}
          onClick={() => setIsAiModeActive(true)}
        />
        <Separator
          orientation="vertical"
          color={'var(--rd-sys-color-border-subtle)'}
          style={{ top: '10px' }}
        />
        <Vertical className={styles['manual-mode-container']} onMouseEnter={handleViewHover}>
          <Button
            text={MANUAL_MODE_HEADER_TOOLTIP}
            type="secondary"
            size="m"
            className={`${styles['buttons']} ${
              !isAiModeActive ? styles['active'] : styles['inactive']
            }`}
            icon={IconID.MANUAL_MODE}
            onClick={() => setIsAiModeActive(false)}
            isDisabled={isStreaming}
            tooltip={isStreaming ? MANUAL_MODE_DISABLED_TOOLTIP : undefined}
          />
          {showView && !isSeenView && <PendoCard handleClose={() => handleViewClose(true)} />}
        </Vertical>
      </Horizontal>
      <Horizontal className={styles['header-container-right']} vAlignContent="center">
        <Horizontal
          className={styles['header-container-right-content']}
          vAlignContent="center"
          onClick={() => setIsHeaderVisible(!isHeaderVisible)}
        >
          <Typography variant="p-bold" className={styles['header-container-content']}>
            {getLabelFromId(activeView)}
          </Typography>
          <Button
            type="tertiary"
            size="m"
            icon={IconID.CHEVRON_DOWN}
            className={`${styles['right-content-button']} ${
              isHeaderVisible ? styles['rotated'] : ''
            }`}
            onClick={() => setIsHeaderVisible(!isHeaderVisible)}
          />
          <Vertical
            className={`${styles['header-popup-container']} ${
              isHeaderVisible ? styles['header-popup-container-visible'] : ''
            }`}
          >
            <Header
              isLoading={isHeaderLoading}
              setIsLoading={setIsHeaderLoading}
              selectedPinboard={embedSelections.pinboard}
              selectedViz={embedSelections.viz}
              selectedDataSource={embedSelections.dataSource}
              selectedAnswer={embedSelections.answerId}
              selectedFullApp={embedSelections.pageId}
              onEmbedSelectionChange={onEmbedSelectionChange}
              onBackClick={goBack}
            />
          </Vertical>
        </Horizontal>
        <DataActions
          openDownloadModal={openDownloadModal}
          openPasteModal={openPasteModal}
          setMessage={setMessageHandler}
        />
      </Horizontal>
      {isHeaderVisible && (
        <Vertical
          className={styles['header-opened-background-shadow']}
          onClick={() => setIsHeaderVisible(false)}
        ></Vertical>
      )}
    </Horizontal>
  );
};
